"use client";

import { useEffect } from "react";
import { GA_MEASUREMENT_ID, canTrack, initializeGoogleTracking, installTrackingBoundary } from "../../lib/googleTracking";

export default function GoogleTracking() {
  useEffect(() => {
    const cleanup = installTrackingBoundary();
    if (!canTrack()) return cleanup;
    initializeGoogleTracking();

    if (!document.getElementById("alpha-google-tag")) {
      const script = document.createElement("script");
      script.id = "alpha-google-tag";
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script);
    }
    return cleanup;
  }, []);

  return null;
}
